var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.989,
    height: 137.865,
    viewBox: "0 0 130.989 137.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_789",
    "data-name": "Raggruppa 789",
    transform: "translate(-1369.25 -229.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_788",
    "data-name": "Raggruppa 788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_787",
    "data-name": "Raggruppa 787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_786",
    "data-name": "Raggruppa 786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_785",
    "data-name": "Raggruppa 785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1445",
    "data-name": "Tracciato 1445",
    d: "M114.307,17.894V59.259A27.569,27.569,0,0,1,86.73,86.836H31.577A27.569,27.569,0,0,1,4,59.259V17.894A6.914,6.914,0,0,1,10.894,11H24.476a6.914,6.914,0,0,1,6.894,6.894V39.542a13.884,13.884,0,0,0,7.308,12.2A13.328,13.328,0,0,0,45.158,53.4a13.534,13.534,0,0,0,7.515-2.275l6.549-4.274,6.067,4.068a13.587,13.587,0,0,0,14.064.758,13.736,13.736,0,0,0,7.377-12.2V17.894A6.914,6.914,0,0,1,93.624,11h13.788A6.914,6.914,0,0,1,114.307,17.894Z",
    transform: "translate(1375.592 280.313)",
    fill: "#1ad598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1446",
    "data-name": "Tracciato 1446",
    d: "M133.489,18.788v6.894c0,7.584-3.654,13.788-13.788,13.788H16.288C5.74,39.471,2.5,33.266,2.5,25.683V18.788C2.5,11.2,5.74,5,16.288,5H119.7C129.836,5,133.489,11.2,133.489,18.788Z",
    transform: "translate(1366.75 244.947)",
    fill: "#1ad598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1447",
    "data-name": "Tracciato 1447",
    d: "M45.636,22.668H7.58a6.456,6.456,0,0,1,.207-8.962l9.79-9.79a6.616,6.616,0,0,1,9.307,0Z",
    transform: "translate(1386.627 227.281)",
    fill: "#1ad598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1448",
    "data-name": "Tracciato 1448",
    d: "M50.406,22.668H12.35L31.1,3.916a6.616,6.616,0,0,1,9.307,0l9.79,9.79A6.456,6.456,0,0,1,50.406,22.668Z",
    transform: "translate(1424.808 227.281)",
    fill: "#1ad598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1449",
    "data-name": "Tracciato 1449",
    d: "M43.618,11a6.914,6.914,0,0,1,6.894,6.894V39.473A6.853,6.853,0,0,1,39.826,45.2l-6.2-4.137a6.888,6.888,0,0,0-7.584,0l-6.481,4.274A6.843,6.843,0,0,1,8.94,39.611V17.894A6.914,6.914,0,0,1,15.834,11Z",
    transform: "translate(1404.709 280.313)",
    fill: "#1ad598"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.9e65932a7c749ddeb62218431bf38c9f.svg";
export { ForwardRef as ReactComponent };